import React from 'react';

export function Events() {
  return <div>Events</div>;
}
